import { Bitrates } from '../config/interfaces';

function coerceMinMax(
  minimum: number | undefined,
  maximum: number | undefined
): { min: number; max: number } {
  // default to 0
  const min = minimum || 0;
  const max = maximum || 0;
  if (min > 0 && (!max || max < min)) {
    return { min, max: Infinity };
  } else if (!min && max && max > min) {
    return { min: 0, max };
  } else {
    return { min, max };
  }
}

export default function coerceBitrates(bitrates: Bitrates): Bitrates {
  const audio = coerceMinMax(
    bitrates.minAudioBitrate,
    bitrates.maxAudioBitrate
  );
  const video = coerceMinMax(
    bitrates.minVideoBitrate,
    bitrates.maxVideoBitrate
  );
  return {
    minAudioBitrate: audio.min,
    maxAudioBitrate: audio.max,
    minVideoBitrate: video.min,
    maxVideoBitrate: video.max
  };
}
